<div class="container pt-3 fade-in-left" id="centerFrame">
    <div class="d-flex align-items-center justify-content-center mb-1 pe-5">
        <a (click)="back()"><div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div></a>
        <div class="p-2 flex-grow-1 pl-2"><h1 class="text-dark text-center">Órdenes de Comercio</h1></div>
    </div>

    <div class="row-cols-12 m-2 mt-0">
        <div class="row p-0 p-md-3 mb-0 align-items-center pt-1">
            <div class="mt-0 text-start mb-3 pb-3">

                <div class="row-cols-12 p-2 mb-3 ps-0 pe-0 input-group fade-in search-input-row">
                    <div class="rounded-start col-md-auto" id="search-addon">
                        <div class="mx-auto d-block p-1 d-inline-flex pt-1 ps-2"><i class="bi bi-search"></i></div>
                    </div>
                    <div class="col rounded">
                        <input
                            type="search"
                            class="form-control search-input shadow-none"
                            placeholder="Buscar por N° de orden, cliente o comercio"
                            aria-label="Search"
                            aria-describedby="search-addon"
                            (keyup)="onSearchInput($any($event.target).value)"
                        />
                    </div>
                </div>

                <div class="mb-3">
                    <select
                        class="form-select filtro-estado"
                        aria-label="Filtrar por estado"
                        (change)="onFiltroEstadoChange($any($event.target).value)"
                    >
                        <option value="">Todos los estados</option>
                        @for (estado of estadosOrdenes(); track estado.id) {
                            <option [value]="estado.id">{{ estado.x_descripcion }}</option>
                        }
                    </select>
                </div>

                @if (error()) {
                    <div class="alert alert-danger mt-2" role="alert">
                        <small>{{ error() }}</small>
                    </div>
                }

                <div class="d-flex align-items-center justify-content-between mb-2">
                    <span class="p-0 m-0">
                        <b>Órdenes ({{ total() }})</b>
                    </span>
                </div>

                @for (orden of ordenes(); track orden.id) {
                    <div class="orden-card mt-3" [routerLink]="['/more-orden-comercio', orden.id]" style="cursor:pointer;">
                        <div class="orden-header">
                            <div class="orden-title">Orden #{{ orden.id }}</div>
                            <div class="orden-fecha">{{ fecha(orden) }}</div>
                        </div>

                        <div class="orden-subtitle">
                            <i class="bi bi-person"></i> Cliente: {{ orden.nombreCliente || 'Sin nombre' }}
                        </div>
                        <div class="orden-subtitle">
                            <i class="bi bi-shop"></i> Comercio: {{ orden.nombreComercio || 'Sin nombre' }}
                        </div>

                        <div class="orden-footer">
                            <span class="estado-label">Estado:</span>
                            <span class="badge-estado" [ngClass]="claseEstadoOrden(orden.estadoOrden)">{{ orden.estadoOrden }}</span>
                        </div>
                    </div>
                } @empty {
                    <div class="text-center text-muted mt-4">No se encontraron órdenes.</div>
                }

                @if (total() > limit) {
                    <div class="d-flex align-items-center justify-content-between mt-4">
                        <button type="button" class="btn-paginar" [disabled]="page() <= 1" (click)="paginaAnterior()">
                            <i class="bi bi-chevron-left"></i> Anterior
                        </button>
                        <span class="text-muted small">Página {{ page() }} de {{ totalPaginas }}</span>
                        <button type="button" class="btn-paginar" [disabled]="page() >= totalPaginas" (click)="paginaSiguiente()">
                            Siguiente <i class="bi bi-chevron-right"></i>
                        </button>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
